// deps
import React, { memo } from "react";

// internal-deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import type { IDinecashEarningsNudge } from "@swiggy-private/checkout-types";

// helpers
import { DINECASH_EARNINGS_NUDGE_TEST_IDS } from "@dineout-cart-ui/helpers/TestIds";

// styles
import { Root, LogoWrap, NudgeText } from "./styles";

interface IDinecashEarningsNudgeProps {
    nudge: IDinecashEarningsNudge;
}

const DinecashEarningsNudge = ({ nudge }: IDinecashEarningsNudgeProps): React.ReactElement => {
    const logoUrl = nudge.logo ? getCloudinaryUrl(nudge.logo) : "";

    return (
        <Root data-testid={DINECASH_EARNINGS_NUDGE_TEST_IDS.CONTAINER}>
            {logoUrl ? (
                <LogoWrap>
                    <Image src={logoUrl} alt="" width="20" height="20" />
                </LogoWrap>
            ) : null}
            <NudgeText variant="V2.overline.neutral.medium" color="text_Med_Emphasis">
                {nudge.text}
            </NudgeText>
        </Root>
    );
};

export default memo(DinecashEarningsNudge);
